<div class="hr-calendar-day__top">
  <div class="hr-calendar-day__ws" aria-hidden="true" test-id="hr-calendar-day-ws">
    <span *ngIf="workScheduleLabel" class="hr-calendar-day__ws-label" test-id="hr-calendar-day-ws-label">{{ workScheduleLabel }}</span>
  </div>
  <span class="hr-calendar-day__number" aria-hidden="true" test-id="hr-calendar-day-number">{{ day.dayOfMonth }}</span>
</div>
<div class="hr-calendar-day__tags" test-id="hr-calendar-day-tags">
  <span *ngFor="let tag of tags; trackBy: trackTag"
        class="hr-calendar-tag hr-calendar-tag--{{ tag.variant || 'neutral' }}"
        test-id="hr-calendar-tag"
        [tooltip]="tag.tooltip"
        container="body"
        placement="top">{{ tag.label }}</span>
</div>

